export default "# News Module Is Now Available\r\nYou can find **development news** and other important **announcements** here.";